import { Types } from '../actions/customMessages'
import { Types as StoreTypes } from '../actions/stores'
import { ArrayUtils } from '../utils'

const initialState = {
    selectedStoreMessages: [],
    isWorking: false,
}

function formatCustomMessage(payload, index) {
    return {
        ...payload,
        index: index + 1,
    }
}

export default (state = initialState, { type, payload = {}, meta = {} }) => {
    switch (type) {
        case Types.CUSTOM_MESSAGES_CREATE_REQUEST:
        case Types.CUSTOM_MESSAGES_DELETE_REQUEST:
        case Types.CUSTOM_MESSAGES_FETCH_REQUEST:
            return {
                ...state,
                isWorking: true,
            }
        case Types.CUSTOM_MESSAGES_FETCH_FAILURE:
        case Types.CUSTOM_MESSAGES_DELETE_FAILURE:
        case Types.CUSTOM_MESSAGES_CREATE_FAILURE:
            return {
                ...state,
                isWorking: false,
            }
        case Types.CUSTOM_MESSAGES_CREATE_SUCCESS: {
            const { selectedStoreMessages } = state

            return {
                ...state,
                isWorking: false,
                selectedStoreMessages: [...selectedStoreMessages, formatCustomMessage(payload, selectedStoreMessages.length)],
            }
        }
        case Types.CUSTOM_MESSAGES_DELETE_SUCCESS: {
            const { selectedStoreMessages: oldArray } = state
            const index = oldArray.findIndex(({ id }) => id === meta.id)
            const selectedStoreMessages = ArrayUtils.removeItem(oldArray, index)

            return {
                ...state,
                isWorking: false,
                selectedStoreMessages,
            }
        }
        case Types.CUSTOM_MESSAGES_FETCH_SUCCESS:
            return {
                ...state,
                isWorking: false,
                selectedStoreMessages: (payload || []).sort(({ id: id1 }, { id: id2 }) => id1 - id2).map(formatCustomMessage),
            }
        case StoreTypes.FETCH_SINGLE_STORE_REQUEST:
            return {
                ...initialState,
            }
        default:
            return state
    }
}

/**
 * Extracts custom messages array from layer extra object
 * @param {Object} [layerExtra]
 * @returns {Array}
 */
function getCustomMessagesFromLayerExtra(layerExtra = {}) {
    return layerExtra.customMessage
}

function getIsWorking(state) {
    return state?.customMessages?.isWorking
}

function getStoreCustomMessages(state) {
    return state?.customMessages?.selectedStoreMessages
}

/**
 * Inserts a new custom messages array into a layer extra object
 * @param {Object} [layerExtra]
 * @param {String>} [customMessage]
 * @returns {Object}
 */
function setCustomMessagesIntoLayerExtra(layerExtra = {}, customMessage) {
    if (!customMessage) {
        const newLayerExtra = { ...layerExtra }
        delete newLayerExtra.customMessage
        return newLayerExtra
    }

    return {
        ...layerExtra,
        customMessage,
    }
}

export { getCustomMessagesFromLayerExtra, getIsWorking, getStoreCustomMessages, setCustomMessagesIntoLayerExtra }
